import React from "react";

export default function SimpleCard({provider}) {
  return (
    <div className="w-full col-span-5 sm:col-span-6 md:col-span-4 lg:col-span-2 xl:col-span-2">
      <div className="bg-white shadow-lg rounded-lg px-4 py-4 mx-4 my-4">
        <div>
          <div className="flex">
            <div className="w-1/2 h-12">
              <p
                className="font-Flama-Regular xl:text-sm lg:text-sm md:text-sm sm:text-xs text-xs"
                color="textSecondary"
              >
                Dirección empresa:
              </p>
            </div>
            <div className="w-full h-12">
              <input
                disabled={true}
                className="w-full"
                value={provider.DIREE}
              ></input>
            </div>
          </div>
          <div className="flex">
            <div className="w-1/2 h-12">
              <p
                className="font-Flama-Regular xl:text-sm lg:text-sm md:text-sm sm:text-xs text-xs"
                color="textSecondary"
              >
                Ciudad:
              </p>
            </div>
            <div className="w-full h-12">
              <input disabled={true} className="w-full" value={provider.CIUDA}></input>
            </div>
          </div>
          <div className="flex">
            <div className="w-1/2 h-12">
              <p
                className="font-Flama-Regular xl:text-sm lg:text-sm md:text-sm sm:text-xs text-xs"
                color="textSecondary"
              >
                Teléfono:
              </p>
            </div>
            <div className="w-full h-12">
              <input
                disabled={true}
                className="w-full"
                value={provider.TELEA}
              ></input>
            </div>
          </div>
          <div className="flex">
            <div className="w-1/2 h-12">
              <p
                className="font-Flama-Regular xl:text-sm lg:text-sm md:text-sm sm:text-xs text-xs"
                color="textSecondary"
              >
                Teléfono móvil:
              </p>
            </div>
            <div className="w-full h-12">
              <input
                disabled={true}
                className="w-full"
                value={provider.CEL1A}
              ></input>
            </div>
          </div>
          <div className="flex">
            <div className="w-1/2 h-12">
              <p
                className="font-Flama-Regular xl:text-sm lg:text-sm md:text-sm sm:text-xs text-xs"
                color="textSecondary"
              >
                Teléfono móvil:
              </p>
            </div>
            <div className="w-full h-12">
              <input disabled={true} className="w-full"></input>
            </div>
          </div>
          <div className="flex">
            <div className="w-1/2 h-12">
              <p
                className="font-Flama-Regular xl:text-sm lg:text-sm md:text-sm sm:text-xs text-xs"
                color="textSecondary"
              >
                E-mail:
              </p>
            </div>
            <div className="w-full h-12">
              <input
                disabled={true}
                className="w-full"
                value={provider.EMAIA}
              ></input>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
